import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { Document } from 'services/documents/types/dtos';
import { Company, ResponseCompanyDto } from '../types/dtos';

type LogoType = 'original' | 'medium' | 'thumbnail' | 'small';

const extractLogo = (logo: Document, type: LogoType) => JSON.parse(logo.filePaths)[type];

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.query<Company, string>({
        async queryFn(companyId, _queryApi, _extraOptions, fetchWithBQ) {
            const companyResult = await fetchWithBQ(`${APP_ENDPOINTS.COMPANY}/${companyId}`);

            if (companyResult.error) return { error: companyResult.error as FetchBaseQueryError };

            const company = companyResult.data as ResponseCompanyDto;

            if (company.documentId) {
                const documentResult = await fetchWithBQ(`${APP_ENDPOINTS.DOCUMENT}/${company.documentId}`);
                if (documentResult.error) return { error: documentResult.error as FetchBaseQueryError };
                const document = documentResult.data as Document;
                return {
                    data: { ...company, logo: extractLogo(document, 'small') },
                };
            }
            return {
                data: company,
            };
        },
        providesTags: [{ type: 'company', id: 'GET-ID' }],
    });
